import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ModalDirective, BsModalRef } from 'ngx-bootstrap/modal';
import { BackendApiService } from '../services/backend-api.service';
import { BackendSocketService } from '../services/backend-socket.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { CommonService } from '../services/common.service';
import _ from 'lodash';
import { NgForm } from '@angular/forms';
import { interval } from 'rxjs';
import * as $ from 'jquery';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { HostListener } from '@angular/core';

@Component({
  selector: 'app-badlaorder',
  templateUrl: './badlaorder.component.html',
  styleUrls: ['./badlaorder.component.scss'],
})
export class BadlaorderComponent implements OnInit, OnDestroy {
  @ViewChild('orderModal') orderModal: ModalDirective;
  @ViewChild('partialOrderModal') partialOrderModal: ModalDirective;
  @ViewChild('rolloverModal') rolloverModal: ModalDirective;

  @ViewChild('deleteModal') deleteModal: ModalDirective;

  @ViewChild('addBadlaOrder') addBadlaOrder: NgForm;

  @ViewChild('openingModal') openingModal: ModalDirective;

  @ViewChild('dollerModal') dollerModal: ModalDirective;

  @ViewChild('editDifferenceModal') editDifferenceModal: ModalDirective;
  @ViewChild('badDetailsRateModal') badDetailsRateModal: ModalDirective;

  @ViewChild('settleModal') settleModal: ModalDirective;
  @ViewChild('settledForm') settledForm: NgForm;
  @ViewChild('avgModal') avgModal: ModalDirective;

  badlaInstrument = [];
  badlaRecord = [];
  mcxBadlaInstrument = [];
  comexBadlaInstrument = [];
  dgcxBadlaInstrument = [];
  allComexInstrument = [];
  allMcxInstrument = [];
  allDgcxInstrument = [];
  badlaOrderList = [];
  permeBadlaOrderList = [];
  subscription;
  subscriptionDetail;
  subscriptionInstrument;
  orderInstruments = [];
  settledIns = [];
  badlaParams: {
    badla: null;
  };
  isBrokrageCheck = false;
  isBrokrageCheckEnd = false;
  isEndClosingRate = false;
  isComexROCheck = false;
  isMcxROCheck = false;
  isDgcxROCheck = false;
  dollerClCheck = false;
  isBrokrageROCheck = false;
  endSubmit = false;
  closingRate;
  filter = {
    mcxbadlaInst: null,
    mcxType: null,
    mcxQty: null,
    mcxPrice: null,
    mcxBroType: null,
    mcxBroAmount: null,
    dgcxbadlaInst: null,
    dgcxType: null,
    dgcxQty: null,
    dgcxPrice: null,
    dgcxBroType: null,
    dgcxBroAmount: null,
    comexbadlaInst: null,
    comexType: null,
    comexQty: null,
    comexPrice: null,
    comexBroType: null,
    comexBroAmount: null,
    type: null,
    id: null,
    duty: null,
    reference: null,
    endandopen: null,
    openingAmount: '0',
    mcxRolloverbadlaInst: null,
    mcxRolloverType: null,
    mcxRolloverQty: null,
    mcxRolloverPrice: null,
    mcxRolloverBroType: null,
    mcxRolloverBroAmount: null,
    comexRolloverbadlaInst: null,
    comexRolloverType: null,
    comexRolloverQty: null,
    comexRolloverPrice: null,
    comexRolloverBroType: null,
    comexRolloverBroAmount: null,
    dgcxRolloverbadlaInst: null,
    dgcxRolloverType: null,
    dgcxRolloverQty: null,
    dgcxRolloverPrice: null,
    dgcxRolloverBroType: null,
    dgcxRolloverBroAmount: null,
    reverse: null,
    partialOrderType: null,
  };
  Toast = {
    type: '',
    title: '',
    timeout: 0,
    body: '',
  };
  diffObject = {
    comexDiffAmt: 0,
    mcxDiffAmt: 0,
    dgcxDiffAmt: 0,
    badlaId: '',
    userId: localStorage.getItem('userId'),
    accessToken: localStorage.getItem('accessToken'),
  };
  overAllResult: any = 0;
  endOrder: Boolean = false;
  userId = localStorage.getItem('userId');
  subscriptionGetRate: Subscription;
  deleteId = null;
  deleteNode;
  roomIdArry = [];
  settlementType = '1';
  buyAvg: any;
  sellAvg: any;
  totalAvg: any;
  openingAmountModal;
  dollerAmountModal;
  customeDollerCheck = false;
  openingBadlaId;
  openingChangeId;
  selectedBadlaType = null;
  withoutFilterScript = [];
  instrumentCategory = [
    { name: 'COPPER' },
    { name: 'CRUD' },
    { name: 'SILVER' },
    { name: 'GOLD' },
    { name: 'GAS' },
  ];
  partialExitingRec;
  statusText: string = 'Expand';
  selectedComexLotSize = 0;
  selectedDgcxLotSize = 0;
  selectedComexLastPrice = 0;
  selectedDgcxLastPrice = 0;
  finalDgQty = 0;
  finalDgRecco = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private backendApiService: BackendApiService,
    private backendSocketService: BackendSocketService,
    private commonService: CommonService,
    private spinnerService: NgxSpinnerService,
  ) {}

  ngOnInit(): void {
    let data = {
      isActive: true,
    };
    this.backendApiService.liveBadlaInstruments(data).subscribe((response) => {
      if (response.status == true) {
        this.badlaInstrument = response.data;
      }
    });

    // this.backendSocketService.leaveAllRoom();
    this.getBadlaOrder();

    this.getRate();
    this.getPL();
    this.getUserDollerRate();
    this.groupInstrument();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.subscriptionGetRate) {
      this.subscriptionGetRate.unsubscribe();
    }
  }

  getBadlaOrder() {
    let data = {
      isOpen: true,
      userId: this.userId,
    };
    this.backendApiService.getBadlaOrder(data).subscribe((response) => {
      if (response.status == true) {
        this.badlaOrderList = response.data;
        // this.badlaOrderList['plDetail']['CalculateBalance'] = this.badlaOrderList['plDetail']['CalculateBalance'].toFixed(2)
        this.badlaOrderList.forEach((element) => {
          let instrumentAry = [];
          // let badlaInstId = element._id;
          // let instrumentToken = element.instrumentToken;
          // instrumentAry = _.map(element.instrumentToken, function (resIns) {
          //   return resIns + "_full";
          // })
          element['comexPrice'] = Number(element['comexPrice']).toFixed(2);
          element['mcxPrice'] = Number(element['mcxPrice']).toFixed(2);
          instrumentAry.push(element.comexbadlaInst + '_full');
          instrumentAry.push(element.dgcxbadlaInst + '_full');
          instrumentAry.push(element.mcxbadlaInst + '_full');

          element.instrumentToken = instrumentAry;
          let orderDetail = {
            checkBrokrage: element['checkBrokrage'],
            comexBroAmount:
              element['checkBrokrage'] == true ? element['comexBroAmount'] : '',
            comexBroType:
              element['checkBrokrage'] == true ? element['comexBroType'] : '',
            mcxBroAmount:
              element['checkBrokrage'] == true ? element['mcxBroAmount'] : '',
            mcxBroType:
              element['checkBrokrage'] == true ? element['mcxBroType'] : '',
            dgcxBroAmount:
              element['checkBrokrage'] == true ? element['dgcxBroAmount'] : '',
            dgcxBroType:
              element['checkBrokrage'] == true ? element['dgcxBroType'] : '',
            comexPrice: element['comexPrice'],
            comexQty: element['comexQty'],
            comexLotSize: element['comexDetail'][0]['lot_size']
              ? element['comexDetail'][0]['lot_size']
              : 1,
            comexInstruments: element['comexDetail'][0]['instrument_token']
              ? element['comexDetail'][0]['instrument_token']
              : '',
            comexType: element['comexType'],
            mcxPrice: element['mcxPrice'],
            mcxQty: element['mcxQty'],
            mcxLotSize: element['mcxDetail'][0]['lot_size']
              ? element['mcxDetail'][0]['lot_size']
              : 1,
            mcxInstruments: element['mcxDetail'][0]['instrument_token']
              ? element['mcxDetail'][0]['instrument_token']
              : '',
            mcxType: element['mcxType'],
            dgcxPrice: element['dgcxPrice'],
            dgcxQty: element['dgcxQty'],
            dgcxLotSize: element['dgcxDetail'][0]['lot_size']
              ? element['dgcxDetail'][0]['lot_size']
              : 1,
            dgcxInstruments: element['dgcxDetail'][0]['instrument_token']
              ? element['dgcxDetail'][0]['instrument_token']
              : '',
            dgcxType: element['dgcxType'],
            orderId: element['_id'],
            openingAmount: element['plDetail']['CalculateBalance']
              ? element['plDetail']['CalculateBalance']
              : 0,
            comexDiffAmt: element['comexDiffAmt']
              ? Number(element['comexDiffAmt'])
              : 0,
            dgcxDiffAmt: element['dgcxDiffAmt']
              ? Number(element['dgcxDiffAmt'])
              : 0,
            mcxDiffAmt: element['mcxDiffAmt']
              ? Number(element['mcxDiffAmt'])
              : 0,
          };
          element.orderDetail = orderDetail;
          setTimeout(() => {
            this.setBadlaInstrument(element);
          }, 300);
        });
        this.permeBadlaOrderList = this.badlaOrderList;
      } else {
        this.badlaOrderList = [];
        this.permeBadlaOrderList = [];
      }
    });
  }

  getPL() {
    let data = {
      isOpen: false,
      userId: this.userId,
    };
    this.backendApiService.getOrderPL(data).subscribe((response) => {
      if (response.status == true) {
        this.overAllResult = Number(response.data).toFixed(2);
      }
    });
  }

  getUserDollerRate() {
    let data = {
      userId: this.userId,
    };
    this.backendApiService.getUserDollerRate(data).subscribe((response) => {
      if (response['status'] == true) {
        if (response['data']) {
          this.customeDollerCheck = true;
          this.dollerAmountModal =
            response['data'] == 0 ? null : Number(response['data']);
        } else {
          this.customeDollerCheck = false;
        }
      } else {
        this.customeDollerCheck = false;
      }
    });
  }

  groupInstrument() {
    let filterData = {
      userId: 1,
    };
    this.backendApiService
      .badlaInstruments(filterData)
      .subscribe((responseBadlaInst) => {
        this.spinnerService.hide();
        if (responseBadlaInst.status == true) {
          this.badlaRecord = responseBadlaInst.data;
          var grpBadla = _.groupBy(this.badlaRecord, 'exchange');
          this.comexBadlaInstrument = grpBadla['COMEX'];
          console.log('this.comexBadlaInstrument', this.comexBadlaInstrument);
          this.mcxBadlaInstrument = grpBadla['MCX'];
          this.dgcxBadlaInstrument = grpBadla['DGCX'];
        }
      });
  }

  setBadlaInstrument(element) {
    element['orderDetail']['equation'] = element['equation'];

    let tokenIds = element.instrumentToken.toString();
    let uniqId = element._id;
    var requested = {
      roomId: this.getRandomString(5),
      instrument_token: tokenIds,
      marketType: 'badlaOrder',
      uniqId: uniqId,
      equation: element.orderDetail,
      response_type: 'full',
      duty: Number(element['duty']),
    };
    var observable = interval(600);
    // this.roomIdArry.push(requested['roomId']);
    this.subscription = observable.subscribe((x) => {
      this.backendSocketService.setInstrument(JSON.stringify(requested));
    });
  }

  showToster(title, type, message) {
    this.Toast.title = title;
    this.Toast.type = type;
    this.Toast.body = message;
    this.commonService.popToast(type, title, 1500, message);
  }

  openBadlaModal() {
    this.isBrokrageCheck = null;
    this.endOrder = false;
    this.clearRate();

    let data = {
      isActive: true,
    };
    this.backendApiService.liveBadlaInstruments(data).subscribe((response) => {
      if (response.status == true) {
        this.badlaInstrument = response.data;
        this.badlaInstrument = _.sortBy(this.badlaInstrument, 'settingName');
        this.withoutFilterScript = response.data;
        this.withoutFilterScript = _.sortBy(
          this.withoutFilterScript,
          'settingName',
        );
      }
    });
    this.filter.id = null;
    let filterData = {
      userId: 1,
    };
    this.backendApiService
      .badlaInstruments(filterData)
      .subscribe((response) => {
        if (response.status == true) {
          this.badlaRecord = response.data;
          var grpBadla = _.groupBy(this.badlaRecord, 'exchange');
          this.mcxBadlaInstrument = grpBadla['MCX'];
          this.comexBadlaInstrument = grpBadla['COMEX'];
          this.dgcxBadlaInstrument = grpBadla['DGCX'];

          this.allComexInstrument = grpBadla['COMEX'];
          this.allMcxInstrument = grpBadla['MCX'];
          this.allDgcxInstrument = grpBadla['DGCX'];
        }
      });

    this.orderModal.show();
  }

  detailsModalOpen() {
    console.log('make chnages');

    this.badDetailsRateModal.show();
  }
  closebadDetailsRateModal() {
    this.badDetailsRateModal.hide();
  }

  openSettledModal() {
    this.clearRate();

    let filterData = {
      userId: this.userId,
    };
    this.backendApiService
      .getDoller(filterData.userId)
      .subscribe((dollerRate) => {
        if (dollerRate['status'] == 1) {
          this.closingRate = dollerRate['data']['dollerRate'];
        }
      });

    this.backendApiService
      .getOrderInstrument(filterData.userId)
      .subscribe((response) => {
        if (response['status'] == true && response['data'].length > 0) {
          let destArray = _.uniqBy(
            response.data[0]['totalInstrument'],
            (x) => x.instrument_token,
          );
          if (destArray) {
            destArray.map(function (dt, key) {
              let instrumentVal = $(
                '#' + dt['instrument_token'] + '_orderLTPInput',
              ).val();
              if (instrumentVal) {
                instrumentVal = Number(instrumentVal);
                instrumentVal = instrumentVal.toFixed(2);
                this.settledIns[dt['instrument_token']] = instrumentVal;
              }
            }, this);
          }
          this.orderInstruments = destArray;
        }
      });

    this.settleModal.show();
  }

  openDollerRateChnage() {
    this.dollerModal.show();
  }

  editBadlaModal(id) {
    this.clearRate();

    $('#dgcxRateId').html('');
    $('#mcxRateId').html('');
    $('#comexRateId').html('');

    this.spinnerService.show();
    this.endOrder = false;
    let data = {
      isActive: true,
    };
    this.backendApiService
      .liveBadlaInstrumentsWithInactive(data)
      .subscribe((responseLive) => {
        if (responseLive.status == true) {
          this.badlaInstrument = responseLive.data;
          let filterData = {
            userId: 1,
          };
          let reqObj = {
            id: id,
          };
          this.backendApiService
            .getSingleBadlaOrder(reqObj)
            .subscribe((response) => {
              if (response.status == true) {
                _.map(this.badlaInstrument, function (resIns) {
                  if (resIns['_id'] == response['data']['type']) {
                  }
                });

                this.filter.comexbadlaInst = response['data']['comexbadlaInst'];
                this.filter.mcxbadlaInst = response['data']['mcxbadlaInst'];
                this.filter.dgcxbadlaInst = response['data']['dgcxbadlaInst'];
                this.filter.mcxType = response['data']['mcxType'];
                this.filter.dgcxType = response['data']['dgcxType'];
                this.filter.comexType = response['data']['comexType'];
                this.filter.mcxQty = response['data']['mcxQty'];
                this.filter.dgcxQty = response['data']['dgcxQty'];
                this.filter.comexQty = response['data']['comexQty'];
                this.filter.mcxPrice = response['data']['mcxPrice'];
                this.filter.dgcxPrice = response['data']['dgcxPrice'];
                this.filter.comexPrice = response['data']['comexPrice'];
                this.filter.type = response['data']['type'];
                this.filter.id = response['data']['_id'];
                this.filter.reference = response['data']['reference'];
                this.filter.duty = response['data']['duty'];
                this.filter.duty = response['data']['duty'];
                this.isBrokrageCheck = response['data']['checkBrokrage'];
                this.filter.mcxBroAmount = response['data']['mcxBroAmount'];
                this.filter.mcxBroType = response['data']['mcxBroType'];
                this.filter.comexBroAmount = response['data']['comexBroAmount'];
                this.filter.comexBroType = response['data']['comexBroType'];
                this.filter.dgcxBroAmount = response['data']['dgcxBroAmount'];
                this.filter.dgcxBroType = response['data']['dgcxBroType'];
                this.filter.openingAmount = response['data']['openingAmount'];

                this.spinnerService.hide();
                setTimeout(() => {
                  this.orderModal.show();
                }, 500);
              }
            });
        }
      });
  }

  partialOrder(id, type) {
    this.clearRate();

    $('#dgcxRateId').html('');
    $('#mcxRateId').html('');
    $('#comexRateId').html('');

    this.spinnerService.show();
    this.endOrder = false;
    let data = {
      isActive: true,
    };
    this.backendApiService
      .liveBadlaInstrumentsWithInactive(data)
      .subscribe((responseLive) => {
        if (responseLive.status == true) {
          this.badlaInstrument = responseLive.data;
          console.log('this.badlaInstrument++++', this.badlaInstrument);

          let reqObj = {
            id: id,
          };
          this.backendApiService
            .getSingleBadlaOrder(reqObj)
            .subscribe((response) => {
              if (response.status == true) {
                this.partialExitingRec = response['data'];
                _.map(this.badlaInstrument, function (resIns) {
                  if (resIns['_id'] == response['data']['type']) {
                  }
                });
                let mcxType =
                  type == 'sell'
                    ? response['data']['mcxType'] == 'buy'
                      ? 'sell'
                      : 'buy'
                    : response['data']['mcxType'];
                let comexType =
                  type == 'sell'
                    ? response['data']['comexType'] == 'buy'
                      ? 'sell'
                      : 'buy'
                    : response['data']['comexType'];
                let dgcxType =
                  type == 'sell'
                    ? response['data']['dgcxType'] == 'buy'
                      ? 'sell'
                      : 'buy'
                    : response['data']['dgcxType'];
                this.filter.comexbadlaInst = response['data']['comexbadlaInst'];
                this.filter.mcxbadlaInst = response['data']['mcxbadlaInst'];
                this.filter.dgcxbadlaInst = response['data']['dgcxbadlaInst'];
                this.filter.mcxType = mcxType;
                this.filter.dgcxType = dgcxType;
                this.filter.comexType = comexType;
                this.filter.mcxQty = 0;
                this.filter.dgcxQty = 0;
                this.filter.comexQty = 0;
                this.filter.mcxPrice = 0;
                this.filter.dgcxPrice = 0;
                this.filter.comexPrice = 0;
                this.filter.type = response['data']['type'];
                this.filter.id = response['data']['_id'];
                this.filter.reference = response['data']['reference'];
                this.filter.duty = response['data']['duty'];
                this.filter.duty = response['data']['duty'];
                this.isBrokrageCheck = response['data']['checkBrokrage'];
                this.filter.mcxBroAmount = 0;
                this.filter.mcxBroType = response['data']['mcxBroType'];
                this.filter.comexBroAmount = 0;
                this.filter.comexBroType = response['data']['comexBroType'];
                this.filter.dgcxBroAmount = 0;
                this.filter.dgcxBroType = response['data']['dgcxBroType'];
                this.filter.openingAmount = '0';
                this.filter.partialOrderType = type;

                this.spinnerService.hide();
                setTimeout(() => {
                  this.partialOrderModal.show();
                }, 500);
              }
            });
        }
      });
  }

  rollbackBadlaModal(id) {
    // this.clearRate();
    $('#dgcxRateId').html('');
    $('#mcxRateId').html('');
    $('#comexRateId').html('');

    this.spinnerService.show();
    this.endOrder = false;
    let data = {
      isActive: true,
    };
    this.backendApiService
      .liveBadlaInstrumentsWithInactive(data)
      .subscribe((responseLive) => {
        if (responseLive.status == true) {
          this.badlaInstrument = responseLive.data;
          let filterData = {
            userId: 1,
          };
          this.backendApiService
            .badlaInstruments(filterData)
            .subscribe((responseBadlaInst) => {
              this.spinnerService.hide();
              // if(responseBadlaInst.status == true){
              //   this.badlaRecord = responseBadlaInst.data;
              //   var grpBadla = _.groupBy(this.badlaRecord, 'exchange');
              //   this.mcxBadlaInstrument = grpBadla['MCX'];
              //   this.comexBadlaInstrument = grpBadla['COMEX'];
              //   this.dgcxBadlaInstrument = grpBadla['DGCX']
              // }
              if (responseBadlaInst.status == true) {
                this.badlaRecord = responseBadlaInst.data;
                var grpBadla = _.groupBy(this.badlaRecord, 'exchange');
                this.mcxBadlaInstrument = grpBadla['MCX'];
                this.comexBadlaInstrument = grpBadla['COMEX'];
                this.dgcxBadlaInstrument = grpBadla['DGCX'];

                this.allComexInstrument = grpBadla['COMEX'];
                this.allMcxInstrument = grpBadla['MCX'];
                this.allDgcxInstrument = grpBadla['DGCX'];
              }
              let reqObj = {
                id: id,
              };
              this.backendApiService
                .getSingleBadlaOrder(reqObj)
                .subscribe((response) => {
                  if (response.status == true) {
                    _.map(this.badlaInstrument, function (resIns) {
                      if (resIns['_id'] == response['data']['type']) {
                        console.log(resIns);
                      }
                    });

                    this.filter.comexbadlaInst =
                      response['data']['comexbadlaInst'];
                    this.filter.mcxbadlaInst = response['data']['mcxbadlaInst'];
                    this.filter.dgcxbadlaInst =
                      response['data']['dgcxbadlaInst'];
                    this.filter.mcxType =
                      response['data']['mcxType'] == 'buy' ? 'sell' : 'buy';
                    this.filter.dgcxType =
                      response['data']['dgcxType'] == 'buy' ? 'sell' : 'buy';
                    this.filter.comexType =
                      response['data']['comexType'] == 'buy' ? 'sell' : 'buy';
                    this.filter.mcxQty = response['data']['mcxQty'];
                    this.filter.dgcxQty = response['data']['dgcxQty'];
                    this.filter.comexQty = response['data']['comexQty'];
                    this.filter.mcxPrice = response['data']['mcxPrice'];
                    this.filter.dgcxPrice = response['data']['dgcxPrice'];
                    this.filter.comexPrice = response['data']['comexPrice'];
                    this.filter.type = response['data']['type'];
                    this.filter.id = response['data']['_id'];
                    this.filter.reference = response['data']['reference'];
                    this.filter.duty = response['data']['duty'];
                    this.filter.duty = response['data']['duty'];
                    this.isBrokrageCheck = false;

                    // this.filter.mcxBroAmount = response['data']['mcxBroAmount'];
                    // this.filter.mcxBroType = response['data']['mcxBroType'];
                    // this.filter.comexBroAmount = response['data']['comexBroAmount'];
                    // this.filter.comexBroType = response['data']['comexBroType'];
                    // this.filter.dgcxBroAmount = response['data']['dgcxBroAmount'];
                    // this.filter.dgcxBroType = response['data']['dgcxBroType'];
                    this.filter.openingAmount =
                      response['data']['openingAmount'];
                    // console.log('badlaInstrument+++++++++',this.badlaInstrument);
                    // console.log('type++++++++',this.filter.type);

                    setTimeout(() => {
                      this.rolloverModal.show();
                    }, 500);
                  }
                });
            });
        }
      });
  }

  averageBadla(id) {
    let data = {
      scriptId: id,
      userId: this.userId,
    };
    this.backendApiService.getAverageBadla(data).subscribe((response) => {
      if (response['status'] == true) {
        this.buyAvg = response['buyAvg'][0];
        this.sellAvg = response['sellAvg'][0];
        this.totalAvg = response['totalAvg'][0];
      }
    });

    this.avgModal.show();
  }

  endBadlaModal(id) {
    // this.clearRate();

    this.spinnerService.show();
    this.endOrder = true;
    let data = {
      isActive: true,
    };
    this.backendApiService
      .liveBadlaInstrumentsWithInactive(data)
      .subscribe((response) => {
        if (response.status == true) {
          this.badlaInstrument = response.data;
        }
        let filterData = {
          userId: 1,
        };
        this.backendApiService
          .badlaInstruments(filterData)
          .subscribe((response) => {
            this.spinnerService.hide();
            if (response.status == true) {
              this.badlaRecord = response.data;
              var grpBadla = _.groupBy(this.badlaRecord, 'exchange');
              this.mcxBadlaInstrument = grpBadla['MCX'];
              this.comexBadlaInstrument = grpBadla['COMEX'];
              this.dgcxBadlaInstrument = grpBadla['DGCX'];
            }
            let data = {
              id: id,
            };
            this.backendApiService
              .getSingleBadlaOrder(data)
              .subscribe((response) => {
                if (response.status == true) {
                  // if(response['data']['checkBrokrage'] == true){
                  //   this.isBrokrageCheck = true;
                  //   this.filter.comexBroType = response['data']['comexBroType'];
                  //   this.filter.mcxBroType = response['data']['mcxBroType'];
                  //   this.filter.dgcxBroType = response['data']['dgcxBroType'];
                  //   this.filter.comexBroAmount = response['data']['comexBroAmount'];
                  //   this.filter.mcxBroAmount = response['data']['mcxBroAmount'];
                  //   this.filter.dgcxBroAmount = response['data']['dgcxBroAmount'];
                  // }
                  let comexBuy = $(
                    '#' + response['data']['comexbadlaInst'] + '_orderBuyInput',
                  ).val();
                  let comexSell = $(
                    '#' +
                      response['data']['comexbadlaInst'] +
                      '_orderSellInput',
                  ).val();
                  let mcxBuy = $(
                    '#' + response['data']['mcxbadlaInst'] + '_orderBuyInput',
                  ).val();
                  let mcxSell = $(
                    '#' + response['data']['mcxbadlaInst'] + '_orderSellInput',
                  ).val();
                  let dgcxBuy = $(
                    '#' + response['data']['dgcxbadlaInst'] + '_orderBuyInput',
                  ).val();
                  let dgcxSell = $(
                    '#' + response['data']['dgcxbadlaInst'] + '_orderSellInput',
                  ).val();

                  this.filter.comexbadlaInst =
                    response['data']['comexbadlaInst'];
                  this.filter.mcxbadlaInst = response['data']['mcxbadlaInst'];
                  this.filter.dgcxbadlaInst = response['data']['dgcxbadlaInst'];
                  this.filter.mcxType =
                    response['data']['mcxType'] == 'buy' ? 'sell' : 'buy';
                  this.filter.dgcxType =
                    response['data']['dgcxType'] == 'buy' ? 'sell' : 'buy';
                  this.filter.comexType =
                    response['data']['comexType'] == 'buy' ? 'sell' : 'buy';
                  this.filter.mcxQty = response['data']['mcxQty'];
                  this.filter.dgcxQty = response['data']['dgcxQty'];
                  this.filter.comexQty = response['data']['comexQty'];
                  this.filter.mcxPrice =
                    response['data']['mcxType'] == 'buy' ? mcxBuy : mcxSell;
                  this.filter.dgcxPrice =
                    response['data']['dgcxType'] == 'buy' ? dgcxBuy : dgcxSell;
                  this.filter.comexPrice =
                    response['data']['comexType'] == 'buy'
                      ? comexBuy
                      : comexSell;
                  this.filter.type = response['data']['type'];
                  this.filter.id = response['data']['_id'];
                  this.filter.reference = response['data']['reference'];
                  this.filter.duty = response['data']['duty'];
                  this.filter.openingAmount = response['data']['openingAmount'];
                  setTimeout(() => {
                    this.orderModal.show();
                  }, 200);
                }
              });
          });
      });
  }

  deleteBadlaModal(id, parentId) {
    if (parentId) {
      this.deleteNode = 1;
      this.deleteId = parentId;
    } else {
      this.deleteNode = 0;
      this.deleteId = id;
    }
    this.deleteModal.show();
  }

  editOpeningModal(id) {
    this.openingBadlaId = id;
    let reqObj = {
      badlaId: id,
    };
    this.backendApiService.getOpeningBalance(reqObj).subscribe((response) => {
      if (response['status'] == true) {
        let amount =
          response['data']['transactionType'] == 'debit'
            ? Number(response['data']['debit']) * -1
            : Number(response['data']['credit']);
        this.openingAmountModal = amount;
        this.openingModal.show();
      } else {
        this.openingAmountModal = 0;
        this.openingModal.show();
      }
    });
  }
  editDifference(id) {
    this.openingChangeId = id;
    let reqObj = {
      badlaId: id,
    };
    console.log('this.badlaOrderList ++++++++++', this.badlaOrderList);
    let badlaDetail = _.find(this.badlaOrderList, function (o) {
      return o.badlRefId == id;
    });
    this.diffObject.comexDiffAmt = badlaDetail['comexDiffAmt']
      ? Number(badlaDetail['comexDiffAmt'])
      : 0;
    this.diffObject.mcxDiffAmt = badlaDetail['mcxDiffAmt']
      ? Number(badlaDetail['mcxDiffAmt'])
      : 0;
    this.diffObject.dgcxDiffAmt = badlaDetail['dgcxDiffAmt']
      ? Number(badlaDetail['dgcxDiffAmt'])
      : 0;

    this.editDifferenceModal.show();
    // this.backendApiService.getDifference(reqObj).subscribe(response => {
    //   console.log('response++++++++',response);
    // })
  }
  closeModal() {
    this.clearRate();
    this.isBrokrageCheck = null;
    this.addBadlaOrder.resetForm();
    this.orderModal.hide();
  }
  closeSettledModal() {
    this.clearRate();
    this.settledForm.resetForm();
    this.settleModal.hide();
  }
  closeDeleteBadlaOrder() {
    this.clearRate();
    this.deleteId = null;
    this.deleteModal.hide();
  }
  closeModalPartialOrder() {
    this.clearRate();
    this.isBrokrageCheck = null;
    this.addBadlaOrder.resetForm();
    this.partialOrderModal.hide();
  }

  closeOpeningModal() {
    this.clearRate();
    this.openingModal.hide();
  }

  closeDollerModal() {
    this.clearRate();
    this.dollerModal.hide();
  }

  closeEditDifferenceModal() {
    this.editDifferenceModal.hide();
  }

  closeRolloverBadlaOrder() {
    this.isComexROCheck = false;
    this.isMcxROCheck = false;
    this.isDgcxROCheck = false;
    this.clearRate();
    // this.clearRate();
    // this.isBrokrageCheck = null;
    // this.addBadlaOrder.resetForm();
    // this.orderModal.hide();
    this.rolloverModal.hide();
  }

  createBadlaOrder() {
    //this.spinnerService.show();
    let type = this.filter['type'];
    let findDiffrence = _.find(this.badlaInstrument, function (o) {
      return o._id == type;
    });
    let reverse = '0';
    if (findDiffrence) {
      reverse = findDiffrence['reverse'] ? findDiffrence['reverse'] : '0';
    }
    let filterInstu = this.filter;
    let mcxbadlaInst = this.filter.mcxbadlaInst;
    let comexbadlaInst = this.filter.comexbadlaInst;
    let dgcxbadlaInst = this.filter.dgcxbadlaInst;
    let badlaId = this.filter.type;
    let mcxDetail = _.find(this.badlaRecord, function (o) {
      return o.instrument_token == mcxbadlaInst;
    });
    let comexDetail = _.find(this.badlaRecord, function (o) {
      return o.instrument_token == comexbadlaInst;
    });
    let dgcxDetail = _.find(this.badlaRecord, function (o) {
      return o.instrument_token == dgcxbadlaInst;
    });
    let findBadlaEquestion = _.find(this.badlaInstrument, function (o) {
      return o._id == badlaId;
    });
    let duty = Number(this.filter['duty']);

    this.filter['mcxDetail'] = mcxDetail ? mcxDetail : [];
    this.filter['comexDetail'] = comexDetail ? comexDetail : [];
    this.filter['dgcxDetail'] = dgcxDetail ? dgcxDetail : [];
    this.filter['checkBrokrage'] = this.isBrokrageCheck;
    let findBadla = findBadlaEquestion['equation'];
    this.filter['settingName'] = findBadlaEquestion['settingName'];
    let totalInstrument = [
      this.filter.mcxbadlaInst,
      this.filter.comexbadlaInst,
      this.filter.dgcxbadlaInst,
    ];
    totalInstrument = _.map(totalInstrument, function (resIns) {
      return resIns + '_full';
    });

    this.backendApiService
      .getLastPrice(totalInstrument)
      .subscribe((badlaLatestRate) => {
        let finalBadla = 0;
        let currentBadla = 0;
        let weeklyBadla = 0;
        if (badlaLatestRate.status == true) {
          let badlaRateRes = [];
          badlaRateRes = _.map(badlaLatestRate.data, function (resIns) {
            return JSON.parse(resIns);
          });
          let mcxLiveRate = _.find(badlaRateRes, function (o) {
            return o.instrument_token == mcxbadlaInst;
          });
          let comexLiveRate = _.find(badlaRateRes, function (o) {
            return o.instrument_token == comexbadlaInst;
          });
          let dgcxLiveRate = _.find(badlaRateRes, function (o) {
            return o.instrument_token == dgcxbadlaInst;
          });

          //taking a variable for price condition
          let dgcxPriceCon =
            this.filter['dgcxType'] == 'buy'
              ? dgcxLiveRate['buy_price_0']
              : dgcxLiveRate['sell_price_0'];
          let comexPriceCon =
            this.filter['comexType'] == 'buy'
              ? comexLiveRate['buy_price_0']
              : comexLiveRate['sell_price_0'];
          let mcxPriceCon =
            this.filter['mcxType'] == 'buy'
              ? mcxLiveRate['buy_price_0']
              : mcxLiveRate['sell_price_0'];
          dgcxPriceCon = 10000 / dgcxPriceCon;
          dgcxPriceCon =
            this.filter.endandopen == '3'
              ? Number(this.closingRate)
              : this.filter.endandopen == '1' && this.isEndClosingRate == true
                ? Number(this.closingRate)
                : dgcxPriceCon;
          let equation = findBadla;
          equation = equation.replace('L1', 'comexPriceCon');
          equation = equation.replace('L1', 'comexPriceCon');
          equation = equation.replace(/L3/g, 'dgcxPriceCon');
          equation = equation.replace(/D1/g, 'duty');

          let equ = eval(equation);
          finalBadla =
            reverse && reverse == '1' ? equ - mcxPriceCon : mcxPriceCon - equ;
          filterInstu['comexPrice'] = Number(filterInstu['comexPrice']);
          filterInstu['dgcxPrice'] = Number(filterInstu['dgcxPrice']);
          let divedDgcx = 10000 / filterInstu['dgcxPrice'];
          divedDgcx =
            this.filter.endandopen == '3'
              ? Number(this.closingRate)
              : this.filter.endandopen == '1' && this.isEndClosingRate == true
                ? Number(this.closingRate)
                : divedDgcx;
          let currentRateEqu = findBadla;
          currentRateEqu = currentRateEqu.replace(
            'L1',
            "filterInstu['comexPrice']",
          );
          currentRateEqu = currentRateEqu.replace(
            'L1',
            "filterInstu['comexPrice']",
          );
          currentRateEqu = currentRateEqu.replace(/L3/g, 'divedDgcx');
          currentRateEqu = currentRateEqu.replace(/D1/g, 'duty');
          let curEqu = eval(currentRateEqu);
          // currentBadla = Number(filterInstu['mcxPrice']) - curEqu;
          currentBadla =
            reverse && reverse == '1'
              ? curEqu - Number(filterInstu['mcxPrice'])
              : Number(filterInstu['mcxPrice']) - curEqu;

          filterInstu['equation'] = findBadla;
          // this.filter['dollerClearingRate'] = dgcxPriceCon;
          let dollerClrRate =
            this.filter.endandopen == '3'
              ? Number(this.closingRate)
              : this.filter.endandopen == '1' && this.isEndClosingRate == true
                ? Number(this.closingRate)
                : 10000 / Number(this.filter['dgcxPrice']);
          this.filter['dollerClearingRate'] = dollerClrRate;

          //weekly settled badla fixed price
          let weeklyDgcx = 10000 / filterInstu['dgcxPrice'];
          let weeklySettleBadla = findBadla;
          weeklySettleBadla = weeklySettleBadla.replace(
            'L1',
            "filterInstu['comexPrice']",
          );
          weeklySettleBadla = weeklySettleBadla.replace(
            'L1',
            "filterInstu['comexPrice']",
          );
          weeklySettleBadla = weeklySettleBadla.replace(/L3/g, 'weeklyDgcx');
          weeklySettleBadla = weeklySettleBadla.replace(/D1/g, 'duty');
          let weeklyEqu = eval(weeklySettleBadla);
          weeklyBadla =
            reverse && reverse == '1'
              ? weeklyEqu - Number(filterInstu['mcxPrice'])
              : Number(filterInstu['mcxPrice']) - weeklyEqu;
        }
        setTimeout(() => {
          let comexD = {
            instrument_token: comexDetail['instrument_token'],
            original_exchange: comexDetail['original_exchange'],
            name: comexDetail['name'],
            tradingsymbol: comexDetail['tradingsymbol'],
            expiry: comexDetail['expiry'],
          };
          let mcxD = {
            instrument_token: mcxDetail['instrument_token'],
            original_exchange: mcxDetail['original_exchange'],
            name: mcxDetail['name'],
            tradingsymbol: mcxDetail['tradingsymbol'],
            expiry: mcxDetail['expiry'],
          };
          let dgcxD = {
            instrument_token: dgcxDetail['instrument_token'],
            original_exchange: dgcxDetail['original_exchange'],
            name: dgcxDetail['name'],
            tradingsymbol: dgcxDetail['tradingsymbol'],
            expiry: dgcxDetail['expiry'],
          };
          this.filter['instrumentAry'] = [comexD, mcxD, dgcxD];
          this.filter['currentBadla'] = finalBadla.toFixed(2);
          this.filter['rateBadla'] = currentBadla.toFixed(2);
          this.filter['userId'] = this.userId;
          if (this.filter.id && this.endOrder == false) {
            //update order
            this.filter.reverse = reverse;
            this.backendApiService
              .updateBadlaOrder(this.filter)
              .subscribe((response) => {
                this.spinnerService.hide();
                if (response.status == true) {
                  this.closeModal();
                  this.showToster('Success', 'success', 'Order Placed...');
                  location.reload();
                  //this.getRate();
                  // this.getBadlaOrder();
                  // this.getPL();
                } else {
                  this.closeModal();
                  this.showToster('Error', 'error', 'Something went wrong.');
                }
              });
          } else if (this.endOrder == true) {
            this.filter['isOpen'] = false;
            this.filter['badlaId'] = this.filter.id;
            this.filter['badlRefId'] = this.getRandomString(6);
            this.filter['weeklySettleBadla'] = weeklyBadla.toFixed(2);
            if (
              this.filter.endandopen == '1' &&
              this.isEndClosingRate == true
            ) {
              this.filter['endClearingCheck'] = true;
            } else {
              this.filter['endClearingCheck'] = false;
            }
            this.filter.reverse = reverse;

            this.backendApiService
              .endBadlaOrder(this.filter)
              .subscribe((response) => {
                this.spinnerService.hide();
                if (response.status == true) {
                  this.closeModal();
                  this.showToster('Success', 'success', 'Order Placed...');
                  location.reload();
                  this.closingRate = null;
                  // if(this.subscriptionGetRate){
                  //   this.subscriptionGetRate.unsubscribe();
                  // }
                  // if(this.subscription){
                  //   this.subscription.unsubscribe();
                  // }
                  // this.getBadlaOrder();
                  // this.getPL();
                  // this.getRate();
                } else {
                  this.closeModal();
                  this.showToster('Error', 'error', 'Something went wrong.');
                }
              });
          } else {
            this.filter['isOpen'] = true;
            this.filter['badlRefId'] = this.getRandomString(6);
            // this.filter['weeklySettleBadla'] = currentBadla.toFixed(0);
            this.filter['openingAmount'] = this.filter['openingAmount']
              ? this.filter['openingAmount']
              : '0';
            this.filter.reverse = reverse;
            this.backendApiService
              .saveBadlaOrder(this.filter)
              .subscribe((response) => {
                if (response.status == true) {
                  this.spinnerService.hide();
                  this.closeModal();
                  this.showToster('Success', 'success', 'Order Placed...');
                  if (this.subscriptionGetRate) {
                    this.subscriptionGetRate.unsubscribe();
                  }
                  this.getBadlaOrder();
                  this.getPL();
                  this.getRate();
                } else {
                  this.closeModal();
                  this.showToster('Error', 'error', 'Something went wrong.');
                }
              });
          }
        }, 300);
      });

    return false;
  }

  partialOrderSubmit() {
    if (this.endSubmit) {
      return;
    }

    this.endSubmit = true;
    let type = this.filter['type'];
    let findDiffrence = _.find(this.badlaInstrument, function (o) {
      return o._id == type;
    });
    if (this.partialExitingRec) {
      console.log(this.partialExitingRec);
      console.log('this.filter', this.filter);
      if (this.filter.comexQty != 0) {
        if (this.filter.partialOrderType == 'sell') {
          if (
            Number(this.filter.comexQty) >
            Number(this.partialExitingRec.comexQty)
          ) {
            this.showToster(
              'Error',
              'error',
              'You cannot sell a quantity exceeding your available holdings.',
            );
            this.endSubmit = false;
            return false;
          }
        }
      }
      if (this.filter.mcxQty != 0) {
        if (this.filter.partialOrderType == 'sell') {
          if (
            Number(this.filter.mcxQty) > Number(this.partialExitingRec.mcxQty)
          ) {
            this.showToster(
              'Error',
              'error',
              'You cannot sell a quantity exceeding your available holdings.',
            );
            this.endSubmit = false;
            return false;
          }
        }
      }
      if (this.filter.dgcxQty != 0) {
        if (this.filter.partialOrderType == 'sell') {
          if (
            Number(this.filter.dgcxQty) > Number(this.partialExitingRec.dgcxQty)
          ) {
            this.showToster(
              'Error',
              'error',
              'You cannot sell a quantity exceeding your available holdings.',
            );
            this.endSubmit = false;
            return false;
          }
        }
      }
      console.log('Asdasd');
      let reverse = '0';
      if (findDiffrence) {
        reverse = findDiffrence['reverse'] ? findDiffrence['reverse'] : '0';
      }
      let filterInstu = this.filter;
      let mcxbadlaInst = this.filter.mcxbadlaInst;
      let comexbadlaInst = this.filter.comexbadlaInst;
      let dgcxbadlaInst = this.filter.dgcxbadlaInst;
      let badlaId = this.filter.type;
      let mcxDetail = _.find(this.badlaRecord, function (o) {
        return o.instrument_token == mcxbadlaInst;
      });
      let comexDetail = _.find(this.badlaRecord, function (o) {
        return o.instrument_token == comexbadlaInst;
      });
      let dgcxDetail = _.find(this.badlaRecord, function (o) {
        return o.instrument_token == dgcxbadlaInst;
      });
      let findBadlaEquestion = _.find(this.badlaInstrument, function (o) {
        return o._id == badlaId;
      });
      let duty = Number(this.filter['duty']);
      if (this.filter.partialOrderType == 'buy') {
        // this code to find average price  in case user want to add (MCX)
        if (
          Number(this.filter['mcxPrice']) != 0 &&
          Number(this.filter['mcxQty']) != 0
        ) {
          let mcxExPrice = Number(this.partialExitingRec['mcxPrice']);
          let mcxExQty = Number(this.partialExitingRec['mcxQty']);
          let mcxUsrPrice = Number(this.filter['mcxPrice']);
          let mcxUsrQty = Number(this.filter['mcxQty']);
          let totalQty = mcxExQty + mcxUsrQty;
          let avgMcxPrice =
            (mcxExPrice * mcxExQty + mcxUsrPrice * mcxUsrQty) / totalQty;
          filterInstu['mcxPriceEx'] = mcxUsrPrice;
          this.filter['mcxPriceEx'] = mcxUsrPrice;
          filterInstu['mcxQtyEx'] = mcxUsrQty;
          this.filter['mcxQtyEx'] = mcxUsrQty;

          filterInstu['mcxPrice'] = avgMcxPrice;
          filterInstu['mcxQty'] = totalQty;
          this.filter['mcxPrice'] = avgMcxPrice;
          this.filter['mcxQty'] = totalQty;
        } else {
          filterInstu['mcxPrice'] = this.partialExitingRec['mcxPrice'];
          filterInstu['mcxQty'] = this.partialExitingRec['mcxQty'];
          this.filter['mcxPrice'] = this.partialExitingRec['mcxPrice'];
          this.filter['mcxQty'] = this.partialExitingRec['mcxQty'];

          filterInstu['mcxPriceEx'] = 0;
          this.filter['mcxPriceEx'] = 0;
          filterInstu['mcxQtyEx'] = 0;
          this.filter['mcxQtyEx'] = 0;
        }

        // this code to find average price  in case user want to add (COMEX)
        if (
          Number(this.filter['comexPrice']) != 0 &&
          Number(this.filter['comexQty']) != 0
        ) {
          let comexExPrice = Number(this.partialExitingRec['comexPrice']);
          let comexExQty = Number(this.partialExitingRec['comexQty']);
          let comexUsrPrice = Number(this.filter['comexPrice']);
          let comexUsrQty = Number(this.filter['comexQty']);
          let totalQty = comexExQty + comexUsrQty;
          let avgMcxPrice =
            (comexExPrice * comexExQty + comexUsrPrice * comexUsrQty) /
            totalQty;
          filterInstu['comexPriceEx'] = comexUsrPrice;
          this.filter['comexPriceEx'] = comexUsrPrice;
          filterInstu['comexQtyEx'] = comexUsrQty;
          this.filter['comexQtyEx'] = comexUsrQty;

          filterInstu['comexPrice'] = avgMcxPrice;
          filterInstu['comexQty'] = totalQty;
          this.filter['comexPrice'] = avgMcxPrice;
          this.filter['comexQty'] = totalQty;
        } else {
          filterInstu['comexPrice'] = this.partialExitingRec['comexPrice'];
          filterInstu['comexQty'] = this.partialExitingRec['comexQty'];
          this.filter['comexPrice'] = this.partialExitingRec['comexPrice'];
          this.filter['comexQty'] = this.partialExitingRec['comexQty'];
          filterInstu['comexPriceEx'] = 0;
          this.filter['comexPriceEx'] = 0;
          filterInstu['comexQtyEx'] = 0;
          this.filter['comexQtyEx'] = 0;
        }

        // this code to find average price  in case user want to add (DGEXCH)
        if (
          Number(this.filter['dgcxPrice']) != 0 &&
          Number(this.filter['dgcxQty']) != 0
        ) {
          let dgcxExPrice = Number(this.partialExitingRec['dgcxPrice']);
          let dgcxExQty = Number(this.partialExitingRec['dgcxQty']);
          let dgcxUsrPrice = Number(this.filter['dgcxPrice']);
          let dgcxUsrQty = Number(this.filter['dgcxQty']);
          let totalQty = dgcxExQty + dgcxUsrQty;
          let avgDgcxPrice =
            (dgcxExPrice * dgcxExQty + dgcxUsrPrice * dgcxUsrQty) / totalQty;

          filterInstu['dgcxPriceEx'] = dgcxUsrPrice;
          this.filter['dgcxPriceEx'] = dgcxUsrPrice;
          filterInstu['dgcxQtyEx'] = dgcxUsrQty;
          this.filter['dgcxQtyEx'] = dgcxUsrQty;

          filterInstu['dgcxPrice'] = avgDgcxPrice;
          filterInstu['dgcxQty'] = totalQty;
          this.filter['dgcxPrice'] = avgDgcxPrice;
          this.filter['dgcxQty'] = totalQty;
        } else {
          filterInstu['dgcxPrice'] = this.partialExitingRec['dgcxPrice'];
          filterInstu['dgcxQty'] = this.partialExitingRec['dgcxQty'];
          this.filter['dgcxPrice'] = this.partialExitingRec['dgcxPrice'];
          this.filter['dgcxQty'] = this.partialExitingRec['dgcxQty'];

          filterInstu['dgcxPriceEx'] = 0;
          this.filter['dgcxPriceEx'] = 0;
          filterInstu['dgcxQtyEx'] = 0;
          this.filter['dgcxQtyEx'] = 0;
        }
      } else {
        // this code to find average price  in case user want to add (MCX)
        if (
          Number(this.filter['mcxPrice']) != 0 &&
          Number(this.filter['mcxQty']) != 0
        ) {
          let mcxExPrice = Number(this.partialExitingRec['mcxPrice']);
          let mcxExQty = Number(this.partialExitingRec['mcxQty']);
          let mcxUsrPrice = Number(this.filter['mcxPrice']);
          let mcxUsrQty = Number(this.filter['mcxQty']);
          let totalQty = mcxExQty - mcxUsrQty;
          filterInstu['mcxRolloverPrice'] = mcxUsrPrice;
          filterInstu['mcxRolloverQty'] = mcxUsrQty;
          this.filter['mcxRolloverPrice'] = mcxUsrPrice;
          this.filter['mcxRolloverQty'] = mcxUsrQty;

          this.filter['mcxPrice'] = mcxExPrice;
          this.filter['mcxQty'] = totalQty;
        } else {
          filterInstu['mcxPrice'] = this.partialExitingRec['mcxPrice'];
          filterInstu['mcxQty'] = this.partialExitingRec['mcxQty'];
          this.filter['mcxPrice'] = this.partialExitingRec['mcxPrice'];
          this.filter['mcxQty'] = this.partialExitingRec['mcxQty'];
        }

        // this code to find average price  in case user want to add (COMEX)
        if (
          Number(this.filter['comexPrice']) != 0 &&
          Number(this.filter['comexQty']) != 0
        ) {
          let comexExPrice = Number(this.partialExitingRec['comexPrice']);
          let comexExQty = Number(this.partialExitingRec['comexQty']);
          let comexUsrPrice = Number(this.filter['comexPrice']);
          let comexUsrQty = Number(this.filter['comexQty']);
          let totalQty = comexExQty - comexUsrQty;
          filterInstu['comexRolloverPrice'] = comexUsrPrice;
          filterInstu['comexRolloverQty'] = comexUsrQty;
          this.filter['comexRolloverPrice'] = comexUsrPrice;
          this.filter['comexRolloverQty'] = comexUsrQty;

          filterInstu['comexPrice'] = comexExPrice;
          filterInstu['comexQty'] = totalQty;
          this.filter['comexPrice'] = comexExPrice;
          this.filter['comexQty'] = totalQty;
        } else {
          filterInstu['comexPrice'] = this.partialExitingRec['comexPrice'];
          filterInstu['comexQty'] = this.partialExitingRec['comexQty'];
          this.filter['comexPrice'] = this.partialExitingRec['comexPrice'];
          this.filter['comexQty'] = this.partialExitingRec['comexQty'];
          filterInstu['comexPriceEx'] = 0;
          this.filter['comexPriceEx'] = 0;
          filterInstu['comexQtyEx'] = 0;
          this.filter['comexQtyEx'] = 0;
        }

        // this code to find average price  in case user want to add (DGEXCH)
        if (
          Number(this.filter['dgcxPrice']) != 0 &&
          Number(this.filter['dgcxQty']) != 0
        ) {
          let dgcxExPrice = Number(this.partialExitingRec['dgcxPrice']);
          let dgcxExQty = Number(this.partialExitingRec['dgcxQty']);
          let dgcxUsrPrice = Number(this.filter['dgcxPrice']);
          let dgcxUsrQty = Number(this.filter['dgcxQty']);
          let totalQty = dgcxExQty - dgcxUsrQty;
          filterInstu['dgcxRolloverPrice'] = dgcxUsrPrice;
          filterInstu['dgcxRolloverQty'] = dgcxUsrQty;
          this.filter['dgcxRolloverPrice'] = dgcxUsrPrice;
          this.filter['dgcxRolloverQty'] = dgcxUsrQty;

          filterInstu['dgcxPrice'] = dgcxExPrice;
          filterInstu['dgcxQty'] = totalQty;
          this.filter['dgcxPrice'] = dgcxExPrice;
          this.filter['dgcxQty'] = totalQty;
        } else {
          filterInstu['dgcxPrice'] = this.partialExitingRec['dgcxPrice'];
          filterInstu['dgcxQty'] = this.partialExitingRec['dgcxQty'];
          this.filter['dgcxPrice'] = this.partialExitingRec['dgcxPrice'];
          this.filter['dgcxQty'] = this.partialExitingRec['dgcxQty'];

          filterInstu['dgcxPriceEx'] = 0;
          this.filter['dgcxPriceEx'] = 0;
          filterInstu['dgcxQtyEx'] = 0;
          this.filter['dgcxQtyEx'] = 0;
        }
      }

      this.filter['badlRefId'] = this.partialExitingRec['badlRefId'];
      this.filter['mcxDetail'] = mcxDetail ? mcxDetail : [];
      this.filter['comexDetail'] = comexDetail ? comexDetail : [];
      this.filter['dgcxDetail'] = dgcxDetail ? dgcxDetail : [];
      this.filter['checkBrokrage'] = this.isBrokrageCheck;
      let findBadla = findBadlaEquestion['equation'];
      this.filter['settingName'] = findBadlaEquestion['settingName'];
      let totalInstrument = [
        this.filter.mcxbadlaInst,
        this.filter.comexbadlaInst,
        this.filter.dgcxbadlaInst,
      ];
      totalInstrument = _.map(totalInstrument, function (resIns) {
        return resIns + '_full';
      });

      this.backendApiService
        .getLastPrice(totalInstrument)
        .subscribe((badlaLatestRate) => {
          let finalBadla = 0;
          let currentBadla = 0;
          let weeklyBadla = 0;
          if (badlaLatestRate.status == true) {
            let badlaRateRes = [];
            badlaRateRes = _.map(badlaLatestRate.data, function (resIns) {
              return JSON.parse(resIns);
            });
            let mcxLiveRate = _.find(badlaRateRes, function (o) {
              return o.instrument_token == mcxbadlaInst;
            });
            let comexLiveRate = _.find(badlaRateRes, function (o) {
              return o.instrument_token == comexbadlaInst;
            });
            let dgcxLiveRate = _.find(badlaRateRes, function (o) {
              return o.instrument_token == dgcxbadlaInst;
            });

            //taking a variable for price condition
            let dgcxPriceCon =
              this.filter['dgcxType'] == 'buy'
                ? dgcxLiveRate['buy_price_0']
                : dgcxLiveRate['sell_price_0'];
            let comexPriceCon =
              this.filter['comexType'] == 'buy'
                ? comexLiveRate['buy_price_0']
                : comexLiveRate['sell_price_0'];
            let mcxPriceCon =
              this.filter['mcxType'] == 'buy'
                ? mcxLiveRate['buy_price_0']
                : mcxLiveRate['sell_price_0'];
            dgcxPriceCon = 10000 / dgcxPriceCon;
            dgcxPriceCon =
              this.filter.endandopen == '3'
                ? Number(this.closingRate)
                : this.filter.endandopen == '1' && this.isEndClosingRate == true
                  ? Number(this.closingRate)
                  : dgcxPriceCon;
            let equation = findBadla;
            equation = equation.replace('L1', 'comexPriceCon');
            equation = equation.replace('L1', 'comexPriceCon');
            equation = equation.replace(/L3/g, 'dgcxPriceCon');
            equation = equation.replace(/D1/g, 'duty');

            let equ = eval(equation);
            finalBadla =
              reverse && reverse == '1' ? equ - mcxPriceCon : mcxPriceCon - equ;
            filterInstu['comexPrice'] = Number(filterInstu['comexPrice']);
            filterInstu['dgcxPrice'] = Number(filterInstu['dgcxPrice']);
            let divedDgcx = 10000 / filterInstu['dgcxPrice'];
            divedDgcx =
              this.filter.endandopen == '3'
                ? Number(this.closingRate)
                : this.filter.endandopen == '1' && this.isEndClosingRate == true
                  ? Number(this.closingRate)
                  : divedDgcx;
            let currentRateEqu = findBadla;
            currentRateEqu = currentRateEqu.replace(
              'L1',
              "filterInstu['comexPrice']",
            );
            currentRateEqu = currentRateEqu.replace(
              'L1',
              "filterInstu['comexPrice']",
            );
            currentRateEqu = currentRateEqu.replace(/L3/g, 'divedDgcx');
            currentRateEqu = currentRateEqu.replace(/D1/g, 'duty');
            let curEqu = eval(currentRateEqu);
            // currentBadla = Number(filterInstu['mcxPrice']) - curEqu;
            currentBadla =
              reverse && reverse == '1'
                ? curEqu - Number(filterInstu['mcxPrice'])
                : Number(filterInstu['mcxPrice']) - curEqu;
            filterInstu['equation'] = findBadla;
            // this.filter['dollerClearingRate'] = dgcxPriceCon;

            //weekly settled badla fixed price
            let weeklyDgcx = 10000 / filterInstu['dgcxPrice'];
            let weeklySettleBadla = findBadla;
            weeklySettleBadla = weeklySettleBadla.replace(
              'L1',
              "filterInstu['comexPrice']",
            );
            weeklySettleBadla = weeklySettleBadla.replace(
              'L1',
              "filterInstu['comexPrice']",
            );
            weeklySettleBadla = weeklySettleBadla.replace(/L3/g, 'weeklyDgcx');
            weeklySettleBadla = weeklySettleBadla.replace(/D1/g, 'duty');
            let weeklyEqu = eval(weeklySettleBadla);
            weeklyBadla =
              reverse && reverse == '1'
                ? weeklyEqu - Number(filterInstu['mcxPrice'])
                : Number(filterInstu['mcxPrice']) - weeklyEqu;
          }
          setTimeout(() => {
            let comexD = {
              instrument_token: comexDetail['instrument_token'],
              original_exchange: comexDetail['original_exchange'],
              name: comexDetail['name'],
              tradingsymbol: comexDetail['tradingsymbol'],
              expiry: comexDetail['expiry'],
            };
            let mcxD = {
              instrument_token: mcxDetail['instrument_token'],
              original_exchange: mcxDetail['original_exchange'],
              name: mcxDetail['name'],
              tradingsymbol: mcxDetail['tradingsymbol'],
              expiry: mcxDetail['expiry'],
            };
            let dgcxD = {
              instrument_token: dgcxDetail['instrument_token'],
              original_exchange: dgcxDetail['original_exchange'],
              name: dgcxDetail['name'],
              tradingsymbol: dgcxDetail['tradingsymbol'],
              expiry: dgcxDetail['expiry'],
            };
            this.filter['instrumentAry'] = [comexD, mcxD, dgcxD];
            this.filter['currentBadla'] = finalBadla.toFixed(2);
            this.filter['rateBadla'] = currentBadla.toFixed(2);
            this.filter['userId'] = this.userId;
            let dollerClrRate =
              this.filter.endandopen == '3'
                ? Number(this.closingRate)
                : 10000 / Number(this.filter['dgcxPrice']);
            this.filter['dollerClearingRate'] = dollerClrRate;
            if (this.filter['partialOrderType'] == 'buy') {
              //update order
              this.backendApiService
                .partialOrder(this.filter)
                .subscribe((response) => {
                  this.spinnerService.hide();
                  if (response.status == true) {
                    this.closeModal();
                    this.showToster('Success', 'success', 'Order Placed...');
                    location.reload();
                    //this.getRate();
                    // this.getBadlaOrder();
                    // this.getPL();
                  } else {
                    this.closeModal();
                    this.showToster('Error', 'error', 'Something went wrong.');
                  }
                });
            } else {
              this.backendApiService
                .partialOrderSell(this.filter)
                .subscribe((response) => {
                  this.spinnerService.hide();
                  if (response.status == true) {
                    this.closeModal();
                    this.showToster('Success', 'success', 'Order Placed...');
                    location.reload();
                    //this.getRate();
                    // this.getBadlaOrder();
                    // this.getPL();
                  } else {
                    this.closeModal();
                    this.showToster('Error', 'error', 'Something went wrong.');
                  }
                });
            }
          }, 300);
        });
    }
  }

  roolbackBadlaOrder() {
    let type = this.filter['type'];
    let findDiffrence = _.find(this.badlaInstrument, function (o) {
      return o._id == type;
    });
    let reverse = '0';
    if (findDiffrence) {
      reverse = findDiffrence['reverse'] ? findDiffrence['reverse'] : '0';
    }
    let filterInstu = this.filter;
    let mcxbadlaInst = filterInstu['mcxRolloverbadlaInst']
      ? filterInstu['mcxRolloverbadlaInst']
      : this.filter.mcxbadlaInst;
    let comexbadlaInst = filterInstu['comexRolloverbadlaInst']
      ? filterInstu['comexRolloverbadlaInst']
      : this.filter.comexbadlaInst;
    let dgcxbadlaInst = filterInstu['dgcxRolloverbadlaInst']
      ? filterInstu['dgcxRolloverbadlaInst']
      : this.filter.dgcxbadlaInst;
    let badlaId = this.filter.type;
    let mcxDetail = _.find(this.badlaRecord, function (o) {
      return o.instrument_token == mcxbadlaInst;
    });
    let comexDetail = _.find(this.badlaRecord, function (o) {
      return o.instrument_token == comexbadlaInst;
    });
    let dgcxDetail = _.find(this.badlaRecord, function (o) {
      return o.instrument_token == dgcxbadlaInst;
    });
    let findBadlaEquestion = _.find(this.badlaInstrument, function (o) {
      return o._id == badlaId;
    });
    let duty = this.filter['duty'];

    this.filter['mcxDetail'] = mcxDetail ? mcxDetail : [];
    this.filter['comexDetail'] = comexDetail ? comexDetail : [];
    this.filter['dgcxDetail'] = dgcxDetail ? dgcxDetail : [];
    this.filter['checkBrokrage'] = this.isBrokrageCheck;
    let findBadla = findBadlaEquestion['equation'];
    let totalInstrument = [mcxbadlaInst, comexbadlaInst, dgcxbadlaInst];
    totalInstrument = _.map(totalInstrument, function (resIns) {
      return resIns + '_full';
    });

    this.backendApiService
      .getLastPrice(totalInstrument)
      .subscribe((badlaLatestRate) => {
        let finalBadla = 0;
        let currentBadla = 0;
        if (badlaLatestRate.status == true) {
          let badlaRateRes = [];
          badlaRateRes = _.map(badlaLatestRate.data, function (resIns) {
            return JSON.parse(resIns);
          });
          let mcxLiveRate = _.find(badlaRateRes, function (o) {
            return o.instrument_token == mcxbadlaInst;
          });
          let comexLiveRate = _.find(badlaRateRes, function (o) {
            return o.instrument_token == comexbadlaInst;
          });
          let dgcxLiveRate = _.find(badlaRateRes, function (o) {
            return o.instrument_token == dgcxbadlaInst;
          });

          dgcxLiveRate['last_price'] = 10000 / dgcxLiveRate['last_price'];
          let equation = findBadla;
          equation = equation.replace('L1', "comexLiveRate['last_price']");
          equation = equation.replace('L1', "comexLiveRate['last_price']");
          equation = equation.replace(/L3/g, "dgcxLiveRate['last_price']");
          equation = equation.replace(/D1/g, 'duty');

          let equ = eval(equation);
          finalBadla =
            reverse && reverse == '1'
              ? equ - mcxLiveRate['last_price']
              : mcxLiveRate['last_price'] - equ;
          filterInstu['comexPrice'] = Number(filterInstu['comexPrice']);
          filterInstu['dgcxPrice'] = Number(filterInstu['dgcxPrice']);

          let divedDgcx = 10000 / filterInstu['dgcxPrice'];
          let currentRateEqu = findBadla;
          currentRateEqu = currentRateEqu.replace(
            'L1',
            "filterInstu['comexPrice']",
          );
          currentRateEqu = currentRateEqu.replace(
            'L1',
            "filterInstu['comexPrice']",
          );
          currentRateEqu = currentRateEqu.replace(/L3/g, 'divedDgcx');
          currentRateEqu = currentRateEqu.replace(/D1/g, 'duty');
          let curEqu = eval(currentRateEqu);
          currentBadla = Number(filterInstu['mcxPrice']) - curEqu;
          filterInstu['equation'] = findBadla;
          this.filter['dollerClearingRate'] = divedDgcx;
        }
        setTimeout(() => {
          let comexD = {
            instrument_token: comexDetail['instrument_token'],
            original_exchange: comexDetail['original_exchange'],
            name: comexDetail['name'],
            tradingsymbol: comexDetail['tradingsymbol'],
            expiry: comexDetail['expiry'],
          };
          let mcxD = {
            instrument_token: mcxDetail['instrument_token'],
            original_exchange: mcxDetail['original_exchange'],
            name: mcxDetail['name'],
            tradingsymbol: mcxDetail['tradingsymbol'],
            expiry: mcxDetail['expiry'],
          };
          let dgcxD = {
            instrument_token: dgcxDetail['instrument_token'],
            original_exchange: dgcxDetail['original_exchange'],
            name: dgcxDetail['name'],
            tradingsymbol: dgcxDetail['tradingsymbol'],
            expiry: dgcxDetail['expiry'],
          };
          this.filter['instrumentAry'] = [comexD, mcxD, dgcxD];
          this.filter['currentBadla'] = finalBadla.toFixed(2);
          this.filter['weeklySettleBadla'] = currentBadla.toFixed(2);
          this.filter['userId'] = this.userId;
          this.filter['isOpen'] = false;
          this.filter['badlaId'] = this.filter.id;
          this.backendApiService
            .rolloverBadlaOrder(this.filter)
            .subscribe((response) => {
              this.spinnerService.hide();
              if (response.status == true) {
                this.closeRolloverBadlaOrder();
                this.showToster('Success', 'success', 'Order Placed...');
                if (this.subscriptionGetRate) {
                  this.subscriptionGetRate.unsubscribe();
                }
                if (this.subscription) {
                  this.subscription.unsubscribe();
                }
                this.getBadlaOrder();
                this.getPL();
                this.getRate();
              } else {
                this.closeRolloverBadlaOrder();
                this.showToster('Error', 'error', 'Something went wrong.');
              }
            });
        }, 300);
      });
  }

  deleteBadlaOrder() {
    let reqObj = {
      delId: this.deleteId,
      userId: this.userId,
      deleteNode: this.deleteNode,
    };
    this.backendApiService.deleteBadlaOrder(reqObj).subscribe((response) => {
      this.deleteModal.hide();
      this.getBadlaOrder();
    });
  }

  openingSubmit() {
    let data = {
      badlaId: this.openingBadlaId,
      openingAmount: this.openingAmountModal,
    };
    this.backendApiService.updateOpeningAmount(data).subscribe((response) => {
      this.showToster('Success', 'success', 'Update Opening...');
      this.openingModal.hide();
      location.reload();
    });
  }
  dollerSubmit() {
    let data = {
      userId: this.userId,
      customeDoller: this.customeDollerCheck ? this.dollerAmountModal : '0',
    };
    this.backendApiService.updateDollerAmount(data).subscribe((response) => {
      this.showToster('Success', 'success', 'Update Opening...');
      this.dollerModal.hide();
      // location.reload();
    });
  }
  differenceSubmit() {
    this.diffObject.badlaId = this.openingChangeId;
    this.backendApiService
      .updatedifference(this.diffObject)
      .subscribe((response) => {
        this.showToster('Success', 'success', 'Update Differences...');
        this.editDifferenceModal.hide();
        location.reload();
      });
  }
  searchPress(event: any) {
    let strLength = event.target.value.length;
    if (strLength > 2) {
      let resultsSearch = _.filter(this.badlaOrderList, (item) =>
        item['reference'].includes(event.target.value),
      );
      this.badlaOrderList = resultsSearch;
    } else {
      this.badlaOrderList = this.permeBadlaOrderList;
    }
  }

  settledBadlaOrder() {
    // this.spinnerService.show();
    let instrAry = this.settledIns;
    let finalInst = [];
    this.settledIns.map(function (o, key) {
      if (instrAry[key]) {
        finalInst.push({ instrument_token: key, settledRate: instrAry[key] });
      }
    });
    let reqObj = {
      finalInst: finalInst,
      userId: this.userId,
      settledBadlaType: this.dollerClCheck == true ? '2' : '3',
      closingRate: this.dollerClCheck == true ? this.closingRate : null,
    };
    this.backendApiService.settledBadlaOrder(reqObj).subscribe((response) => {
      this.spinnerService.hide();
      this.dollerClCheck = false;
      if (response.status == true) {
        this.closeSettledModal();
        this.showToster('Success', 'success', 'Settled Successfully...');
        this.getBadlaOrder();
        this.getPL();
      } else {
        this.closeSettledModal();
        this.showToster('Error', 'error', 'Something went wrong.');
      }
    });
  }

  settlementTypeChnage(id) {
    this.backendApiService.getDoller(1).subscribe((dollerRate) => {
      if (dollerRate['status'] == 1) {
        this.closingRate = dollerRate['data']['dollerRate'];
      }
    });
    this.settlementType = id;
  }
  comexTypeChnage() {
    if (this.filter.comexType == 'buy') {
      this.filter.mcxType = 'sell';
      this.filter.dgcxType = 'sell';
    } else if (this.filter.comexType == 'sell') {
      this.filter.mcxType = 'buy';
      this.filter.dgcxType = 'buy';
    } else {
      this.filter.mcxType = '';
      this.filter.dgcxType = '';
    }
  }

  getRandomString(length) {
    var result = '';
    var characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  getRate() {
    this.subscriptionGetRate = this.backendSocketService
      .getInstrument()
      .subscribe((response) => {
        if (response['marketType'] == 'badlaOrder') {
          let reverse = '0';
          let findBadlaOrder = this.badlaOrderList.find(
            (b) => b._id == response['uniqId'],
          );
          if (findBadlaOrder) {
            let findDiffrence = _.find(this.badlaInstrument, function (o) {
              return o._id == findBadlaOrder['type'];
            });
            if (findDiffrence) {
              reverse = findDiffrence['reverse']
                ? findDiffrence['reverse']
                : '0';
            }
          }
          // console.log('sddddddddd++++++++++',response['equation']);
          //$("#" + response.uniqId + "_comex").html("123456");
          // $("#" + response.uniqId + "_mcx").html("456456456");
          // $("#" + response.uniqId + "_mcx").html("75325995");
          //find Comex
          let comexDetail = _.find(response.data, function (o) {
            return (
              o.instrument_token == response['equation']['comexInstruments']
            );
          });
          let mcxDetail = _.find(response.data, function (o) {
            return o.instrument_token == response['equation']['mcxInstruments'];
          });
          let dgcxDetail = _.find(response.data, function (o) {
            return (
              o.instrument_token == response['equation']['dgcxInstruments']
            );
          });
          if (dgcxDetail && mcxDetail && comexDetail) {
            if (response['equation']['comexDiffAmt'] != 0) {
              comexDetail['buy_price_0'] =
                comexDetail['buy_price_0'] +
                response['equation']['comexDiffAmt'];
              comexDetail['sell_price_0'] =
                comexDetail['sell_price_0'] +
                response['equation']['comexDiffAmt'];
            }
            if (response['equation']['mcxDiffAmt'] != 0) {
              mcxDetail['buy_price_0'] =
                mcxDetail['buy_price_0'] + response['equation']['mcxDiffAmt'];
              mcxDetail['sell_price_0'] =
                mcxDetail['sell_price_0'] + response['equation']['mcxDiffAmt'];
            }
            if (response['equation']['dgcxDiffAmt'] != 0) {
              dgcxDetail['buy_price_0'] =
                dgcxDetail['buy_price_0'] + response['equation']['dgcxDiffAmt'];
              dgcxDetail['sell_price_0'] =
                dgcxDetail['sell_price_0'] +
                response['equation']['dgcxDiffAmt'];
            }

            $('.' + comexDetail['instrument_token'] + '_orderBuy').html(
              comexDetail['buy_price_0'],
            );
            $('.' + comexDetail['instrument_token'] + '_orderSell').html(
              comexDetail['sell_price_0'],
            );
            $('#' + comexDetail['instrument_token'] + '_orderBuyInput').val(
              comexDetail['buy_price_0'],
            );
            $('#' + comexDetail['instrument_token'] + '_orderSellInput').val(
              comexDetail['sell_price_0'],
            );
            $('#' + comexDetail['instrument_token'] + '_orderLTPInput').val(
              comexDetail['last_price'],
            );

            $('.' + mcxDetail['instrument_token'] + '_orderBuy').html(
              mcxDetail['buy_price_0'],
            );
            $('.' + mcxDetail['instrument_token'] + '_orderSell').html(
              mcxDetail['sell_price_0'],
            );
            $('#' + mcxDetail['instrument_token'] + '_orderBuyInput').val(
              mcxDetail['buy_price_0'],
            );
            $('#' + mcxDetail['instrument_token'] + '_orderSellInput').val(
              mcxDetail['sell_price_0'],
            );
            $('#' + mcxDetail['instrument_token'] + '_orderLTPInput').val(
              mcxDetail['last_price'],
            );

            $('.' + dgcxDetail['instrument_token'] + '_orderBuy').html(
              dgcxDetail['buy_price_0'],
            );
            $('.' + dgcxDetail['instrument_token'] + '_orderSell').html(
              dgcxDetail['sell_price_0'],
            );
            $('#' + dgcxDetail['instrument_token'] + '_orderBuyInput').val(
              dgcxDetail['buy_price_0'],
            );
            $('#' + dgcxDetail['instrument_token'] + '_orderSellInput').val(
              dgcxDetail['sell_price_0'],
            );
            $('#' + dgcxDetail['instrument_token'] + '_orderLTPInput').val(
              dgcxDetail['last_price'],
            );
            dgcxDetail['last_price'] = dgcxDetail['last_price']
              ? dgcxDetail['last_price']
              : 0;
            let dollerPrice = this.dollerAmountModal
              ? this.dollerAmountModal
              : dgcxDetail['last_price'] == 0
                ? 0
                : 10000 / dgcxDetail['last_price'];
            let brockRageDG = this.dollerAmountModal
              ? this.dollerAmountModal
              : dgcxDetail['last_price'] == 0
                ? 0
                : 10000 / dgcxDetail['last_price'];
            // console.log('dollerPrice+++++++++',dollerPrice);
            // console.log('brockRageDG+++++++++',brockRageDG);

            let cmpComex =
              response['equation']['comexType'] == 'buy'
                ? comexDetail['buy_price_0']
                : comexDetail['sell_price_0'];
            let comexMultiple =
              response['equation']['comexType'] == 'buy' ? 1 : -1;
            let comexOpenAvg = response['equation']['comexPrice'];
            let qtyComex = response['equation']['comexQty'];
            let comexLotSize = response['equation']['comexLotSize'];
            // console.log("-----------------------------------------------------");
            // console.log("cmpComex+++++++++",cmpComex);
            // console.log("comexOpenAvg+++++++++",comexOpenAvg);
            // console.log("qtyComex+++++++++",qtyComex);
            // console.log("comexLotSize",comexLotSize);
            // console.log("comexMultiple",comexMultiple);
            // console.log("-----------------------------------------------------");
            let comexResult =
              (cmpComex - comexOpenAvg) *
              qtyComex *
              comexLotSize *
              comexMultiple;
            let withoutDollerComex = comexResult;
            comexResult = comexResult * dollerPrice;

            let fixedComex = comexResult.toFixed(2);
            let fixedwithoutDollerComex = withoutDollerComex.toFixed(2);

            $('#' + response.uniqId + '_comex').html(fixedComex);
            let comexClass =
              Number(fixedComex) > 0 ? 'buy-class' : 'sell-class';
            $('#' + response.uniqId + '_comex').addClass(comexClass);

            //without doller
            $('#' + response.uniqId + '_comex_wdlr').html(
              fixedwithoutDollerComex,
            );
            let withoutComexClass =
              Number(fixedwithoutDollerComex) > 0 ? 'buy-class' : 'sell-class';
            $('#' + response.uniqId + '_comex_wdlr').addClass(
              withoutComexClass,
            );

            let fixedComexBroSum = 0;
            let fixedComexBro = 0;
            //comex brokrage calculater
            if (response['equation']['checkBrokrage'] == true) {
              let comexbro =
                Number(response['equation']['comexBroAmount']) *
                qtyComex *
                brockRageDG;
              let comexbroSum = comexResult - comexbro;
              fixedComexBroSum = Number(comexbroSum.toFixed(2));
              fixedComexBro = Number(comexbro.toFixed(2));
              $('#' + response.uniqId + '_comex_bro').html(
                String(fixedComexBro),
              );
              $('#' + response.uniqId + '_comex_bro').addClass('sell-class');

              $('#' + response.uniqId + '_comex_bro_total').html(
                String(fixedComexBroSum),
              );
              let comexBroClass =
                Number(fixedComexBroSum) > 0 ? 'buy-class' : 'sell-class';
              $('#' + response.uniqId + '_comex_bro_total').addClass(
                comexBroClass,
              );
            } else {
              $('#' + response.uniqId + '_comex_bro_total').html(fixedComex);
              $('#' + response.uniqId + '_comex_bro_total').addClass(
                comexClass,
              );
            }

            let mcxComex =
              response['equation']['mcxType'] == 'buy'
                ? mcxDetail['buy_price_0']
                : mcxDetail['sell_price_0'];
            let mcxMultiple = response['equation']['mcxType'] == 'buy' ? 1 : -1;
            let mcxOpenAvg = response['equation']['mcxPrice'];
            let qtyMcx = response['equation']['mcxQty'];
            let mcxLotSize = response['equation']['mcxLotSize'];
            let mcxResult =
              (mcxComex - mcxOpenAvg) * qtyMcx * mcxLotSize * mcxMultiple;
            //mcxResult = mcxResult * dollerPrice;
            let fixedMcx = mcxResult.toFixed(2);
            $('#' + response.uniqId + '_mcx').html(fixedMcx);
            let mcxClass = Number(fixedMcx) > 0 ? 'buy-class' : 'sell-class';
            $('#' + response.uniqId + '_mcx').addClass(mcxClass);

            //without doller
            let fixedMcxWithoutDoller =
              dollerPrice == 0 ? 0 : Number(fixedMcx) / dollerPrice;
            let mcxClassWith =
              Number(fixedMcxWithoutDoller) > 0 ? 'buy-class' : 'sell-class';
            $('#' + response.uniqId + '_mcx_wdlr').html(
              fixedMcxWithoutDoller.toFixed(2),
            );
            $('#' + response.uniqId + '_mcx_wdlr').addClass(mcxClassWith);

            let fixedMcxBroSum = 0;
            let fixedMcxBro = 0;
            //dgcx brokrage calculater
            if (response['equation']['checkBrokrage'] == true) {
              if (response['equation']['mcxBroType'] == 'per') {
                let mcxbro =
                  (Number(response['equation']['mcxPrice']) *
                    qtyMcx *
                    mcxLotSize *
                    Number(response['equation']['mcxBroAmount'])) /
                  100000;
                let mcxbroSum = mcxResult - mcxbro;
                fixedMcxBroSum = Number(mcxbroSum.toFixed(2));
                fixedMcxBro = Number(mcxbro.toFixed(2));
                $('#' + response.uniqId + '_mcx_bro').html(String(fixedMcxBro));
                $('#' + response.uniqId + '_mcx_bro').addClass('sell-class');

                $('#' + response.uniqId + '_mcx_bro_total').html(
                  String(fixedMcxBroSum),
                );
                let mcxBroClass =
                  Number(fixedMcxBroSum) > 0 ? 'buy-class' : 'sell-class';
                $('#' + response.uniqId + '_mcx_bro_total').addClass(
                  mcxBroClass,
                );
              } else {
                let mcxbro =
                  Number(response['equation']['mcxBroAmount']) * qtyMcx;
                let mcxbroSum = mcxResult - mcxbro;
                fixedMcxBroSum = Number(mcxbroSum.toFixed(2));
                fixedMcxBro = Number(mcxbro.toFixed(2));

                $('#' + response.uniqId + '_mcx_bro').html(String(fixedMcxBro));
                $('#' + response.uniqId + '_mcx_bro').addClass('sell-class');

                $('#' + response.uniqId + '_mcx_bro_total').html(
                  String(fixedMcxBroSum),
                );
                let mcxBroClass =
                  Number(fixedMcxBroSum) > 0 ? 'buy-class' : 'sell-class';
                $('#' + response.uniqId + '_mcx_bro_total').addClass(
                  mcxBroClass,
                );
              }
            } else {
              $('#' + response.uniqId + '_mcx_bro_total').html(fixedMcx);
              $('#' + response.uniqId + '_mcx_bro_total').addClass(mcxClass);
            }

            let dgcxComex =
              response['equation']['dgcxType'] == 'buy'
                ? dgcxDetail['buy_price_0']
                : dgcxDetail['sell_price_0'];
            let dgcxMultiple =
              response['equation']['dgcxType'] == 'buy' ? 1 : -1;
            let dgcxOpenAvg = response['equation']['dgcxPrice'];
            let qtyDgcx = response['equation']['dgcxQty'];
            let dgcxLotSize = response['equation']['dgcxLotSize'];
            let dgcxResult =
              (dgcxComex - dgcxOpenAvg) * qtyDgcx * dgcxLotSize * dgcxMultiple;
            let withoutDollerdgcx = dgcxResult;
            dgcxResult = dgcxResult * dollerPrice;
            let openingTtl = Number(response['equation']['openingAmount']);
            let fixedDgcx = dgcxResult.toFixed(2);
            let fixedDgcxWithoutDoller = withoutDollerdgcx.toFixed(2);

            $('#' + response.uniqId + '_dgcx').html(fixedDgcx);
            let dgcxClass = Number(fixedDgcx) > 0 ? 'buy-class' : 'sell-class';
            $('#' + response.uniqId + '_dgcx').addClass(dgcxClass);

            //without doller
            $('#' + response.uniqId + '_dgcx_wdlr').html(
              fixedDgcxWithoutDoller,
            );
            let dgcxClassWithoutDoller =
              Number(fixedDgcxWithoutDoller) > 0 ? 'buy-class' : 'sell-class';
            $('#' + response.uniqId + '_dgcx_wdlr').addClass(
              dgcxClassWithoutDoller,
            );

            let fixedDgcxBroSum = 0;
            let fixedDgcxBro = 0;
            //dgcx brokrage calculater
            if (response['equation']['checkBrokrage'] == true) {
              let dgcxbro =
                Number(response['equation']['dgcxBroAmount']) *
                qtyDgcx *
                brockRageDG;
              let dgcxbroSum = dgcxResult - dgcxbro;
              fixedDgcxBroSum = Number(dgcxbroSum.toFixed(2));
              fixedDgcxBro = Number(dgcxbro.toFixed(2));
              $('#' + response.uniqId + '_dgcx_bro').html(String(fixedDgcxBro));
              $('#' + response.uniqId + '_dgcx_bro').addClass('sell-class');

              $('#' + response.uniqId + '_dgcx_bro_total').html(
                String(fixedDgcxBroSum),
              );
              let dgcxBroClass =
                Number(fixedDgcxBroSum) > 0 ? 'buy-class' : 'sell-class';
              $('#' + response.uniqId + '_dgcx_bro_total').addClass(
                dgcxBroClass,
              );
            } else {
              $('#' + response.uniqId + '_dgcx_bro_total').html(fixedDgcx);
              $('#' + response.uniqId + '_dgcx_bro_total').addClass(dgcxClass);
            }

            //sum of without brokrage
            let totalProfit =
              Number(fixedComex) + Number(fixedMcx) + Number(fixedDgcx);
            let fixedTotalProfit = totalProfit.toFixed(2);

            let totalProfitWithoutDoller =
              Number(fixedwithoutDollerComex) +
              Number(fixedMcxWithoutDoller) +
              Number(fixedDgcxWithoutDoller);
            let fixedTotalProfitWithoutDoller =
              totalProfitWithoutDoller.toFixed(2);
            $('#' + response.uniqId + '_total_wdlr').html(
              fixedTotalProfitWithoutDoller,
            );
            let totalClassWithoutDoller =
              Number(totalProfitWithoutDoller) > 0 ? 'buy-class' : 'sell-class';
            $('#' + response.uniqId + '_total_wdlr').addClass(
              totalClassWithoutDoller,
            );

            $('#' + response.uniqId + '_total').html(fixedTotalProfit);
            let afterOpeni = totalProfit + openingTtl;
            let afterOpeniFixed = afterOpeni.toFixed(2);
            $('#' + response.uniqId + '_withOpeningPL').html(afterOpeniFixed);
            let afterOpeniClass =
              Number(afterOpeniFixed) > 0 ? 'buy-class' : 'sell-class';
            $('#' + response.uniqId + '_withOpeningPL').addClass(
              afterOpeniClass,
            );

            let totalClass =
              Number(totalProfit) > 0 ? 'buy-class' : 'sell-class';
            $('#' + response.uniqId + '_total').addClass(totalClass);

            //sum of brokrage
            let brock =
              Number(fixedComexBro) +
              Number(fixedMcxBro) +
              Number(fixedDgcxBro);
            let fixedBrock = brock.toFixed(2);
            $('#' + response.uniqId + '_total_bro').html(fixedBrock);
            $('#' + response.uniqId + '_total_bro').addClass('sell-class');

            //sum of brokrage and profit
            let totalBro = 0;
            if (response['equation']['checkBrokrage'] == true) {
              totalBro =
                Number(fixedComexBroSum) +
                Number(fixedMcxBroSum) +
                Number(fixedDgcxBroSum);
            } else {
              totalBro =
                Number(fixedComex) + Number(fixedMcx) + Number(fixedDgcx);
            }
            let fixedTotalBro = totalBro.toFixed(2);
            $('#' + response.uniqId + '_total_sum').html(fixedTotalBro);
            let totalClassBro =
              Number(totalBro) > 0 ? 'buy-class' : 'sell-class';
            $('#' + response.uniqId + '_total_sum').addClass(totalClassBro);

            let afterOpeniSum = totalBro + openingTtl;
            let afterOpeniSumFixed = afterOpeniSum.toFixed(2);
            $('#' + response.uniqId + '_withOpeningSum').html(
              afterOpeniSumFixed,
            );
            let afterOpeniSumClass =
              Number(afterOpeniSumFixed) > 0 ? 'buy-class' : 'sell-class';
            $('#' + response.uniqId + '_withOpeningSum').addClass(
              afterOpeniSumClass,
            );

            let comexPriceCon =
              response['equation']['comexType'] == 'sell'
                ? comexDetail['sell_price_0']
                : comexDetail['buy_price_0'];
            let mcxPriceCon =
              response['equation']['mcxType'] == 'sell'
                ? mcxDetail['sell_price_0']
                : mcxDetail['buy_price_0'];
            let dgcxPriceCon =
              response['equation']['dgcxType'] == 'sell'
                ? dgcxDetail['sell_price_0']
                : dgcxDetail['buy_price_0'];

            let duty = response['duty'];
            let dgcxLprice = dgcxPriceCon == 0 ? 0 : 10000 / dgcxPriceCon;
            let equation = response['equation']['equation'];
            equation = equation.replace('L1', 'comexPriceCon');
            equation = equation.replace('L1', 'comexPriceCon');
            equation = equation.replace(/L2/g, 'mcxPriceCon');
            equation = equation.replace(/L3/g, 'dgcxLprice');
            equation = equation.replace(/D1/g, 'duty');
            // console.log('duty+++++++',duty);
            //     console.log('equation+++++++',equation);
            let equ = eval(equation);
            let finalBadla =
              reverse && reverse == '1' ? equ - mcxPriceCon : mcxPriceCon - equ;

            let finalBadlaFix = finalBadla.toFixed(2);
            let totalBadlaClass =
              Number(finalBadlaFix) > 0 ? 'buy-class' : 'sell-class';
            $('#' + response.uniqId + '_currentBadla').addClass(
              totalBadlaClass,
            );

            $('#' + response.uniqId + '_currentBadla').html(finalBadlaFix);
          }
          //upend rate
        }

        //  let cmpResult = (cmpComex - )
        // console.log('comexDetail++++++++',comexDetail);
        // console.log('mcxDetail++++++++',mcxDetail);
        // console.log('dgcxDetail++++++++',dgcxDetail);

        // console.log('response++++++++++',response);
      });
  }

  badlaScriptChnage(id) {
    console.log('id+++++++', id);
    let badlaDuty = _.find(this.badlaInstrument, function (o) {
      return o._id == id;
    });
    if (badlaDuty) {
      this.filter['duty'] = badlaDuty['settingValue'][0]['Duty'];
      let badlaType = badlaDuty['badlaType'] ? badlaDuty['badlaType'] : null;
      if (badlaType) {
        let filterComex = [];
        // console.log('badlaType++++++',badlaType);
        // console.log(this['allComexInstrument']);
        _.map(this['allComexInstrument'], function (resIns) {
          let position = -1;
          if (badlaType == 'GOLD') {
            position = resIns['name'].search(/gold/i);
          }
          if (badlaType == 'SILVER') {
            position = resIns['name'].search(/silver/i);
          }
          if (badlaType == 'COPPER') {
            position = resIns['name'].search(/copper/i);
          }
          if (badlaType == 'CRUDE') {
            // console.log(resIns['name']);
            position = resIns['name'].search(/crude/i);
          }
          if (badlaType == 'GAS') {
            position = resIns['name'].search(/GAS/);
          }

          if (position != -1) {
            filterComex.push(resIns);
          }
        });
        this['comexBadlaInstrument'] = filterComex;

        let filterMcx = [];
        _.map(this['allMcxInstrument'], function (resIns) {
          let position = -1;
          if (badlaType == 'GOLD') {
            position = resIns['name'].search(/gold/i);
          }
          if (badlaType == 'SILVER') {
            position = resIns['name'].search(/silver/i);
          }
          if (badlaType == 'COPPER') {
            position = resIns['name'].search(/copper/i);
          }
          if (badlaType == 'CRUDE') {
            console.log(resIns['name']);
            position = resIns['name'].search(/crude/i);
          }
          if (badlaType == 'GAS') {
            position = resIns['name'].search(/GAS/);
          }

          if (position != -1) {
            filterMcx.push(resIns);
          }
        });
        this['mcxBadlaInstrument'] = filterMcx;
      } else {
        this['comexBadlaInstrument'] = this['allComexInstrument'];
        this['mcxBadlaInstrument'] = this['allMcxInstrument'];
        this['dhcxBadlaInstrument'] = this['allDgcxInstrument'];
      }
    }
  }

  checkBrokrage(check) {
    this.isBrokrageCheck = check;
  }
  checkBrokrageEnd(check) {
    this.isBrokrageCheck = check;
  }

  checkEndClosing(check) {
    this.isEndClosingRate = check;
  }

  checkBrokrageRO(check) {
    this.isBrokrageROCheck = check;
  }

  clearingRate(check) {
    this.dollerClCheck = check;
  }

  checkRollover(instrumentType, check) {
    this.badlaScriptChnage(this.filter.type);
    if (instrumentType == 'comex') {
      this.filter.comexRolloverType =
        this.filter.comexType == 'buy' ? 'sell' : 'buy';
      this.filter.comexRolloverQty = this.filter.comexQty;
      this.isComexROCheck = check;
    }
    if (instrumentType == 'mcx') {
      this.filter.mcxRolloverType =
        this.filter.mcxType == 'buy' ? 'sell' : 'buy';
      this.filter.mcxRolloverQty = this.filter.mcxQty;
      this.isMcxROCheck = check;
    }
    if (instrumentType == 'dgcx') {
      this.filter.dgcxRolloverType =
        this.filter.dgcxType == 'buy' ? 'sell' : 'buy';
      this.filter.dgcxRolloverQty = this.filter.dgcxQty;
      this.isDgcxROCheck = check;
    }
  }

  chnageInsrument(instrumentToken, id) {
    console.log('this.filter', this.filter);
    console.log('this.selectedBadlaType', this.selectedBadlaType);
    let comexSingleIns;
    let comexLotSize = 0;
    let dgcxSingleIns;
    let dgcxLotSize = 0;
    if (id == 'comexRateId') {
      comexSingleIns = this.comexBadlaInstrument.find(
        (res) => res.instrument_token == instrumentToken,
      );
      if (comexSingleIns) {
        comexLotSize = Number(comexSingleIns['lot_size']);
        this.selectedComexLotSize = Number(comexLotSize);
      }
    }
    if (id == 'dgcxRateId') {
      console.log(
        'this.dgcxRateIdInstrument++++++++',
        this.dgcxBadlaInstrument,
      );
      dgcxSingleIns = this.dgcxBadlaInstrument.find(
        (res) => res.instrument_token == instrumentToken,
      );
      if (dgcxSingleIns) {
        dgcxLotSize = Number(dgcxSingleIns['lot_size']);
        this.selectedDgcxLotSize = Number(dgcxLotSize);
      }
    }
    if (instrumentToken[0] != 0) {
      let totalInstrument = [instrumentToken + '_full'];
      this.backendApiService
        .getLastPrice(totalInstrument)
        .subscribe((badlaLatestRate) => {
          console.log('badlaLatestRate+++++++');
          if (
            badlaLatestRate['status'] == true &&
            badlaLatestRate['data'].length > 0
          ) {
            let badlaRateRes = _.map(
              badlaLatestRate['data'],
              function (resIns) {
                return JSON.parse(resIns);
              },
            );

            let price =
              badlaRateRes[0]['buy_price_0'] +
              ' | ' +
              badlaRateRes[0]['sell_price_0'];
            if (id == 'comexRateId') {
              this.selectedComexLastPrice = Number(
                badlaRateRes[0]['last_price'],
              );
            }
            if (id == 'dgcxRateId') {
              this.selectedDgcxLastPrice = Number(
                badlaRateRes[0]['last_price'],
              );
              let goldPrice =
                this.selectedComexLastPrice * this.selectedComexLotSize;
              goldPrice = goldPrice * (10000 / this.selectedDgcxLastPrice);
              goldPrice = goldPrice / 2000000;
              this.finalDgRecco = true;
              this.finalDgQty = Math.round(goldPrice);
              if (this.filter['comexQty']) {
                this.finalDgQty =
                  Math.round(goldPrice) * Number(this.filter['comexQty']);
              }
            }

            $('#' + id).html(price);
            $('#' + id + 'Rollover').html(price);
          }
        });
    } else {
      $('#' + id).html('');
    }
  }

  updateDgexcQty() {
    if (Number(this.filter['comexQty']) && Number(this.filter['comexQty'])) {
      if (this.finalDgQty != 0) {
        let goldPrice = this.selectedComexLastPrice * this.selectedComexLotSize;
        goldPrice = goldPrice * (10000 / this.selectedDgcxLastPrice);
        goldPrice = goldPrice / 2000000;
        this.finalDgRecco = true;
        this.finalDgQty = Math.round(goldPrice);
        if (this.filter['comexQty']) {
          this.finalDgQty =
            Math.round(goldPrice) * Number(this.filter['comexQty']);
        }
      }
    }
  }

  clearRate() {
    $('#dgcxRateId').html('');
    $('#mcxRateId').html('');
    $('#comexRateId').html('');
    this.closingRate = null;
    this.dollerClCheck = false;
    this.settlementType = '';
    this.filter.type = null;
  }

  closeAvgModal() {
    this.avgModal.hide();
  }

  badlaTypeChnage(type) {
    this.selectedBadlaType = type;
    console.log('this.selectedBadlaType++++++', this.selectedBadlaType);
    this.badlaInstrument = [];
    if (type == '0: null') {
      this.badlaInstrument = this.withoutFilterScript;
    } else {
      console.log('asdasdasd', this.withoutFilterScript);
      let filterCategoryWise = _.filter(this.withoutFilterScript, function (o) {
        if (o['badlaType'] == type) {
          return o;
        }
      });
      this.badlaInstrument = filterCategoryWise;
    }
  }
  chageStatusText(text) {
    if (text == 'Expand') {
      this.statusText = 'Collapse';
    } else {
      this.statusText = 'Expand';
    }
  }

  @HostListener('document:keydown.escape', ['$event'])
  handleEscapeKey(event: KeyboardEvent): void {
    this.clearRate();
    this.isBrokrageCheck = null;
    this.addBadlaOrder.resetForm();
  }

  // openDetailBadla(id){
  //   console.log($("#"+id).attr('class'));
  // }
}
